module.exports = "<div class=row> <div class=col-lg-12> <div class=\"wrapper wrapper-content\"> <div class=ibox> <div class=ibox-content> <h2>Interpretation of raw data</h2> <h3>Inputs</h3> <crud-input-curate></crud-input-curate> <h3>Input Content Types</h3> <crud-input-content-type-curate></crud-input-content-type-curate> <h3>Interpreters</h3> <crud-interpreter-curate></crud-interpreter-curate> </div> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/debug/interpretation-of-raw-data.html
// module id = 4144
// module chunks = 86